import React from "react";

import { Button } from "@mui/material";

type Props = React.ComponentProps<typeof Button> & { title: string };

const IconButton: React.FC<Props> = (props) => {
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={props.startIcon}
      {...props}
    >
      {props.title}
    </Button>
  );
};

export default IconButton;
